import { AnchorElementsSource } from '../types/AnchorElementsSource';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { GetSharingInfoResponseBase } from 'owa-fileprovider-link-services';
import { action } from 'satcheljs';

// TODO VSO 33492: mutators should not take in the object they are mutating as a parameter.
export const addSharingLink = action(
    'ADD_SHARING_LINK',
    (
        linkId: string,
        url: string,
        sharingLinkIds: string[],
        response: GetSharingInfoResponseBase,
        source: AnchorElementsSource,
        providerType: AttachmentDataProviderType
    ) => ({
        linkId: linkId,
        url: url,
        sharingLinkIds: sharingLinkIds,
        response: response,
        source: source,
        providerType: providerType,
    })
);

// TODO VSO 33492: mutators should not take in the object they are mutating as a parameter.
export const sharingLinkRemoved = action(
    'SHARING_LINK_REMOVED',
    (linkId: string, sharingLinkIds: string[]) => ({
        linkId: linkId,
        sharingLinkIds: sharingLinkIds,
    })
);

export const deleteLink = action('DELETE_LINK', (linkId: string) => ({
    linkId: linkId,
}));

export const createAttachmentFromLink = action(
    'CREATE_ATTACHMENT_FROM_LINK',
    (linkId: string, providerId: string, isTryAgain: boolean) => ({
        linkId: linkId,
        providerId: providerId,
        isTryAgain: isTryAgain,
    })
);

// TODO VSO 33492: mutators should not take in the object they are mutating as a parameter.
export const addSharingLinkToContianer = action(
    'ADD_SHARING_LINK_TO_CONTAINER',
    (linkId: string, linkIdContainer: string[]) => ({
        linkId: linkId,
        linkIdContainer: linkIdContainer,
    })
);
